import { compose, withProps } from 'recompose'
import {
  getLink,
  getMeta,
  getTitle,
  getCanonicalUrl,
  getImage,
  getDescription,
  isPageForSitewideSchema
} from './helpers'
import { isNotFoundPage } from 'helpers/isNotFoundPage'
import { getPageLocation } from 'selectors'
import Head from './Head'
import { connect } from 'react-redux'


const mapStateToProps = state => {
  const pageLocation = getPageLocation(state)

  return {
    isNotFoundPage: isNotFoundPage(pageLocation && pageLocation.pathname)
  }
}

const withHeadData = withProps(({ data }) => {
  let currentUrl = ''

  if (window && window.location) {
    currentUrl = window.location.href
  }

  return {
    canonicalUrl: data.canonical ? getCanonicalUrl(data) : currentUrl,
    image: data ? getImage(data) : '',
    description: data ? getDescription(data) : '',
    title: data ? getTitle(data) : '',
    meta: data ? getMeta(data) : '',
    link: data ? getLink(data) : ''
  }
})

const withIsPageForSchema = withProps(({ canonicalUrl }) => ({
  isPageForSitewideSchema: isPageForSitewideSchema(canonicalUrl)
}))

export default compose(
  connect(mapStateToProps),
  withHeadData,
  withIsPageForSchema
)(Head)
